
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798f8f","stroke-linejoin":"round"}},[_c('path',{staticClass:"i-stroke",attrs:{"d":"M12.266 15.5A7.06 7.06 0 0 0 15.5 9.553c0-3.895-3.134-7.053-7-7.053s-7 3.158-7 7.053A7.06 7.06 0 0 0 4.734 15.5 3.93 3.93 0 0 1 8.5 12.65a3.93 3.93 0 0 1 3.766 2.85Z"}}),_c('path',{staticClass:"i-stroke_2",attrs:{"d":"M11 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z"}})])])
          )
        }
      }
    